import React from 'react'
    import {LoginIcon} from '../Shared/Images/image';
import { NavLink, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { toLower } from 'lodash';

class Header extends React.Component {
     state ={
         show : false
     }
     toggleNavbar =()=>{
         this.setState({
             show : !this.state.show
         })
     }
    render(){
        return (
            <header className="header">
                <div className="header-wrap">
                    <div className="mx-width">
                        <nav className="navbar navbar-expand-lg  bg-white">
                            <Link className="navbar-brand navbar-logo" to="/">
                                <img src={LoginIcon} alt="logoImag" width="170" />
                            </Link>
                            <button className="navbar-toggler navToggler collapsed" type="button" onClick={this.toggleNavbar} data-toggle="collapse" data-target="#navbarCollapse" aria-controls="navbarCollapse" aria-expanded="false" aria-label="Toggle navigation">
                                <span className="b-icon"></span>
                                <span className="b-icon"></span>
                                <span className="b-icon"></span>                        
                            </button>                    
                            <div className={`navbar-collapse collapse ${this.state.show ? "show" : ''}`}>                        
                                <ul className="navbar-nav ml-auto top-navbar-list">
                                    <li className="nav-item"><NavLink className="nav-link navbar__link" activeClassName="navbar__link--active"  to="/aboutus">About Us</NavLink></li>
                                    <li className="nav-item inner-top-link">
                                        <NavLink className="nav-link navbar__link" activeClassName="navbar__link--active" exact={true}  to="/">Countries</NavLink>
                                        <ul className="inner-top-list list-unstyled">
                                            {
                                               this.props.contries === undefined ? <li>undefined</li> : 
                                               this.props.contries.map(contary=>{
                                                return(
                                                    <li key={contary.name}><Link to={"/eligibility/" + toLower(contary.name) + "/step1"}>{contary.name}</Link></li>
                                                )
                                            })                                                 
                                            }
                                        </ul>
                                    </li>
                                    <li className="nav-item inner-top-link">
                                        <NavLink className="nav-link navbar__link"   to="">Services</NavLink>
                                        <ul className="inner-top-list list-unstyled">
                                            <li><Link to="/services/ielts">Ielts</Link></li>
                                            <li><Link to="/services/degreeattestation">Degree Attestation</Link></li>
                                            <li><Link to="/services/immigration">Immigration</Link></li>
                                
                                        </ul>
                                    </li>
                                    <li className="nav-item"><NavLink className="nav-link navbar__link" activeClassName="navbar__link--active"  to="/progress">Track Progress</NavLink></li>
                                    <li className="nav-item"><NavLink className="nav-link navbar__link" activeClassName="navbar__link--active"  to="/contactus">Contact Us</NavLink></li>
                                </ul>
                                 
                            </div>           
                        </nav>
                    </div>
                </div>
            </header>
        )
    }
}
const mapStateToProps = state =>{
    return{
        contries : state.contries
    }
}
const mapDispatchToProps = dispatch => {   
    return {
        onSetCountry: (name) => dispatch({type: 'SET_COUNTARY', name:name}) 
    }
};
export default connect(mapStateToProps, mapDispatchToProps)(Header);